<template>
  <div class="tablePage">
    <el-table
      v-loading="loading"
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      :header-cell-style="headCellStyle"
      stripe
      :height="tableHeight"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50" />
      <el-table-column
        v-if="isSys"
        prop="sceneName"
        :label="$t('public.table_scope')"
        show-overflow-tooltip
      />
      <el-table-column
        prop="gasCode"
        :label="$t('integration.number')"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          <DeviceCode :device="row">
            <template #icon="{device}">
              <i
                v-icon:theme="['gasTypeConvert', device.type]"
                v-if="!$slots.icon"
              ></i>
            </template>
            <template #name="{device}">
              <el-popover placement="top-start" width="auto" trigger="hover">
                <v-popoer :rowData="device" :typeWay="typeWay" />
                <span
                  slot="reference"
                  :class="{
                    bolder: device.status === ENUM_SENSOR_STATUS.OFFLINE
                  }"
                  >{{ device.gasCode }}</span
                >
              </el-popover>
            </template>
          </DeviceCode>
        </template>
      </el-table-column>

      <!-- 除了未确认都存在 -->
      <el-table-column
        prop="gatewayName"
        :label="$t('device.forward_gateway')"
        show-overflow-tooltip
        width="170"
      >
        <template #default="{ row }">
          <span style="cursor: pointer" @click="gatwayDetail(row.gatewayId)">
            {{ row.gatewayName }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="probeValue"
        :label="$t('device.current_probe_value')"
        width="250px"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          <div class="temp-class" v-if="isSHowProbeValueFn(row)">
            <span class="t-h-time">{{
              generJsonFn1(row.probeValue, 'time')
            }}</span>
            <span
              class="t-h-val"
              :class="classFn(row, 'temp')"
              :title="$t('public.jump_to_history')"
              @click="$emit('historyFn', row)"
              >{{ generJsonFn1(row.probeValue, row.type ===6 ? 'coz' : 'gas') }}</span
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="updateTime"
        :label="$t('public.update_time')"
        show-overflow-tooltip
      >
        <template #default="{row}">
          {{ $timetransition(row.updateTime) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="optare"
        fixed="right"
        :label="$t('public.table_operation')"
        width="120"
      >
        <template #default="{ row }">
          <template v-for="item in optareBtn">
            <el-button
              type="text"
              v-if="item.id === 2 ? getTabs(row.type).length : true"
              size="small"
              :key="item.id"
              :title="$t(item.title)"
              :icon="item.icon"
              @click="handle(item.method, row)"
            ></el-button>
          </template>

          <!-- v-has="item.vHas" -->
        </template>
      </el-table-column>
    </el-table>

    <GatewayDialog
      :visible.sync="dialogVisible"
      :gatewayId="gatewayId"
    ></GatewayDialog>
  </div>
</template>

<script>
import popover from '../components/Popover.vue'
import DeviceCode from '@/pages/equipment/publicCom/DeviceCode.vue'
import { getIsSys } from '@/utils/permission'
import { ENUM_DEVICE_STATUS } from '@/common/enum/forward/device'
import GatewayDialog from '@/pages/equipment/publicCom/GatewayDialog.vue'
import { getTabs } from '@/components/dialog/gasDetail/tabController'

export default {
  name: 'Table',
  components: {
    GatewayDialog,
    DeviceCode,
    'v-popoer': popover
  },
  props: ['loading', 'tableData'],
  computed: {
    ENUM_SENSOR_STATUS () {
      return ENUM_DEVICE_STATUS
    },
    i18n () {
      return this.$i18n.locale
    },
    isSys () {
      return getIsSys()
    }
  },
  data () {
    return {
      tableHeight: '100%',
      gatewayId: 0,
      optareBtn: [
        {
          id: 1,
          title: $t('public.stop'),
          icon: 'el-icon-video-pause',
          vHas: [],
          method: 'stopUseFn'
        },
        {
          id: 2,
          title: $t('public.config'),
          icon: 'el-icon-setting',
          vHas: [],
          method: 'configFn'
        },
        {
          id: 3,
          title: 'public.details',
          icon: 'el-icon-tickets',
          vHas: [],
          method: 'detailFn'
        },
      ],
      dialogVisible: false,
      typeWay: 'unbind'
    }
  },
  mounted () {},
  methods: {
    getTabs,
    handleSelectionChange (arg) {
      this.$emit('choozeTable', arg)
    },
    handle (method, row) {
      this.$emit(method, row)
    },
    /** 数据状态 */
    styleFn (row) {
      if (row.status === 1) {
        return {
          color: '#65cea7',
          'font-weight': 'bold',
          cursor: 'pointer'
        }
      } else {
        return {
          color: 'red',
          cursor: 'pointer'
        }
      }
    },
    /** json转换 */
    /**
     *
     * @param {*匹配字段} key
     * @param {*数组} array
     * @param {*返回数据} str
     */
    /** json转换 */
    generJsonFn1 (sample_value, s) {
      if (!sample_value) return
      let str = ' '
      const { gas, coz } = JSON.parse(sample_value)
      if (!gas && !coz) return
      if (s === 'gas') {
        // str = gas.val + this.unit.temp.name
        str = gas.val + gas.unit
      }else if(s === 'coz'){
        str = coz.val + "%vol"
      }else {
        if(gas){
          str = this.$timetransition(gas.time)
        }else if(coz){
          str = this.$timetransition(coz.time)
        }
      }

      return str
    },
    /** 根据id获取监测点关联的网关信息 */
    gatwayDetail (id) {
      this.dialogVisible = true
      this.gatewayId = id
    },

    classFn (row, text) {
      if (!row.probeValue) return

      let className = ''
      if (text === 'temp') {
        const { temp } = JSON.parse(row.probeValue)
        if (!temp || !row.tempRange) return
        className =
          temp.val > row.tempRange.max
            ? 'higher-range-bg'
            : temp.val < row.tempRange.min
              ? 'lower-range-bg'
              : ''
      } else {
        const { hum } = JSON.parse(row.probeValue)
        if (!hum || !row.humidityRange) return
        className =
          hum.val > row.humidityRange.max
            ? 'higher-range-bg'
            : hum.val < row.humidityRange.min
              ? 'lower-range-bg'
              : ''
      }

      return className
      // const { hum } = JSON.parse(probe_value)
    },
    // 校准图标hover字样内容
    contentFn(row){
      if(row.calibrationType === 1){
        return this.$t('device.calibration_expiration') + ':' + this.$timetransition(row.calibrationExpireTime, 'Y-M-D')
      }
      if(row.calibrationType === 0){
        return $t('device.no_calibration')
      }
      return $t('device.no_set_calibration')
    },
    isSHowProbeValueFn(row){
      // if(row.type === 6){
      //   return JSON.parse(row.probeValue).coz ? true : false
      // }else{
      //   return JSON.parse(row.probeValue).gas ? true : false
      // }
      return  JSON.parse(row.probeValue).gas || JSON.parse(row.probeValue).coz 
    }
  }
}
</script>

<style lang="scss" scoped>
.tablePage {
  height: calc(100% - 60px);

  .temp-class,
  .hum-class {
    height: 26px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .t-h-time {
      flex: 3;
      text-align: center;
      background-color: var(--primary-color);
      color: #ffffff;
      border-radius: 2px;
      font-size: 12px;
      border: 1px solid var(--primary-color);
      border-right: none;
      border-radius: 2px 0px 0px 2px;
    }

    .t-h-val {
      flex: 1;
      border-radius: 2px;
      font-size: 12px;
      text-align: center;
      border: 1px solid var(--primary-color);
      border-left: none;
      border-radius: 0px 2px 2px 0px;
      cursor: pointer;
    }
  }
}
</style>
